import type { ComponentProps } from 'react';
import type { CartesianGrid, Tooltip, XAxis, YAxis } from 'recharts';

export const CHART_MARGIN = { top: 0, right: 0, bottom: 0, left: 0 };

export const chartGridProps: ComponentProps<typeof CartesianGrid> = {
  strokeDasharray: '3 3',
  stroke: 'hsl(var(--muted-foreground) / 0.1)',
};

export const chartXAxisProps: ComponentProps<typeof XAxis> = {
  dataKey: 'month',
  stroke: 'hsl(var(--muted-foreground) / 0.7)',
  fontSize: 10,
  strokeWidth: 0.5,
};

export const chartYAxisProps: ComponentProps<typeof YAxis> = {
  stroke: 'hsl(var(--muted-foreground) / 0.7)',
  fontSize: 10,
  strokeWidth: 0,
};

export const chartTooltipContentStyle: ComponentProps<
  typeof Tooltip
>['contentStyle'] = {
  backgroundColor: 'hsl(var(--popover))',
  borderColor: 'hsl(var(--border))',
  borderRadius: 'var(--radius)',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.5)',
};

export const chartTooltipItemStyle: ComponentProps<
  typeof Tooltip
>['itemStyle'] = {
  color: 'hsl(var(--popover-foreground))',
};

export const chartTooltipLabelStyle: ComponentProps<
  typeof Tooltip
>['labelStyle'] = {
  color: 'hsl(var(--muted-foreground))',
};

export const chartBarTooltipCursor = {
  fill: 'hsl(var(--muted))',
  fillOpacity: 0.6,
};
